import React from 'react';

import useRouteHandlers from '~/router/useRouteHandlers';

function withRouteHandlers(Component) {
  function ComponentWithRouterHandlersProp(props) {
    const routeHandlers = useRouteHandlers();
    return <Component {...props} routeHandlers={routeHandlers} />;
  }

  ComponentWithRouterHandlersProp.displayName = `withRouteHandlers(${Component.displayName})`;
  return ComponentWithRouterHandlersProp;
}

export default withRouteHandlers;
